// Full-document render of the stearns ProductComparePage: PageSkeleton (the
// React document shell) wrapping the existing ProductComparePageBody
// assembly (which reproduces the field-level product-compare-page-block section
// and serializes its compare_grid SSR envelopes inside the `modules` pick). The
// legacy product_compare_page.html body was a single <main> island; PageSkeleton
// supplies <main id="main-content">, so only the body assembly renders here.
import React from "react";

import { templates } from "@reactivated";

import { PageSkeleton } from "../components/PageSkeleton";
import { ProductComparePageBody } from "../components/ProductComparePageBody";

// Mutable reactivated props (not Immutable<>): this template composes the
// in-tree SiteHeader/RichNavigation chain via PageSkeleton, which is typed with
// mutable reactivated props. The body island accepts Immutable props, to which
// these are assignable.
export const Template = (
    props: templates.StearnsProductComparePageTemplate,
): React.JSX.Element => (
    <PageSkeleton pageChrome={props.page_chrome}>
        <ProductComparePageBody page={props.page} />
    </PageSkeleton>
);
